import { shallowEqual, useSelector } from 'react-redux';
import anonymous from '../../security/anonymous';
import { ITEMS_COLLECTION, SITES_COLLECTION, USERS_COLLECTION, } from '../collections';

export const initializedSelector = state => state.initialized;

export const useInitialized = () => {
  return useSelector(initializedSelector);
};

export const authenticatedSelector = state => state.initialized && state.auth.tokenAndUser.user !== anonymous;

export const useAuthenticated = () => {
  return useSelector(authenticatedSelector);
};

export const tokenSelector = state => state.auth.tokenAndUser.token;

export const useToken = () => {
  return useSelector(tokenSelector);
}

export const meSelector = state => state.auth.tokenAndUser.user;

export const useMe = () => {
  return useSelector(meSelector, shallowEqual);
}

export const loginFormSelector = state => state.auth.login;

export const useLoginForm = () => {
  return useSelector(loginFormSelector, shallowEqual);
};

export const collectionListSelector = collection => state => state.data[collection].list;
export const collectionItemSelector = (collection, id) => state => state.data[collection].list.items.filter(o => o.id === id);
export const collectionFormSelector = collection => state => state.data[collection].form;

const makeCollectionListHook = collection => () => {
  return useSelector(collectionListSelector(collection), shallowEqual);
};

const makeCollectionItemHook = collection => id => {
  return useSelector(collectionItemSelector(collection, id), shallowEqual);
};

const makeCollectionFormHook = collection => () => {
  return useSelector(collectionFormSelector(collection), shallowEqual);
};

export const useSites = makeCollectionListHook(SITES_COLLECTION);

export const useSiteForm = makeCollectionFormHook(SITES_COLLECTION);

export const useSite = makeCollectionItemHook(SITES_COLLECTION);

export const useItems = makeCollectionListHook(ITEMS_COLLECTION);

export const useItemForm = makeCollectionFormHook(ITEMS_COLLECTION);

export const useUsers = makeCollectionListHook(USERS_COLLECTION);

export const useUserForm = makeCollectionFormHook(USERS_COLLECTION);

export const dashboardSelector = state => state.dashboard;

export const useDashboard = () => {
  return useSelector(dashboardSelector);
};
